<template>
    <div class="video-grid">
      <VideoPageCard
        v-for="(video, index) in videos"
        :key="index"
        :video="video"
      />
    </div>
  </template>
  
  <script>
 import VideoPageCard from './VideoPageCard.vue';
  
  export default {
    name: "VideoPageGrid",
    components: { VideoPageCard },
    props: {
      videos: {
        type: Array,
        required: true
      }
    }
  };
  </script>
  
  <style scoped>

  .video-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr); /* 🖥 Desktop: 6 columns */
    gap: 20px;
  }

  /* 📲 Tablets (iPad portrait & landscape) */
    @media (max-width: 1024px) {
    .video-grid {
        grid-template-columns: repeat(4, 1fr);
    }
    }
  
  /* 📱 Mobile */
  @media (max-width: 768px) {
    .video-grid {
      grid-template-columns: repeat(2, 1fr); /* 2 columns */
      gap: 4px;
    }
  }


  </style>
  